import { render, staticRenderFns } from "./Sentence.vue?vue&type=template&id=10cccae4&scoped=true&"
import script from "./Sentence.vue?vue&type=script&lang=ts&"
export * from "./Sentence.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Sentence.vue?vue&type=style&index=0&id=10cccae4&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10cccae4",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cccae4')) {
      api.createRecord('10cccae4', component.options)
    } else {
      api.reload('10cccae4', component.options)
    }
    module.hot.accept("./Sentence.vue?vue&type=template&id=10cccae4&scoped=true&", function () {
      api.rerender('10cccae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CallTranscription/Sentence.vue"
export default component.exports